import { webHiddenScrollbarProps } from "../../../platform/design/scrollWeb";
import { webDialogWidth } from "../../../platform/design/dialogWeb";
import { View, Text, TouchableOpacity, FlatList, useWindowDimensions, StyleSheet,Platform, DeviceEventEmitter } from 'react-native'
import React, { useEffect, useRef, useState } from 'react'
import { Theme, ThemeConsumer } from '@rneui/themed'

import { getCategoryProductsForSellScreen } from '../../../redux/slices/sellScreenSlice'
import { config } from '../../../shared/environment'
import { useAppNavigation } from '../../../types/@react-navigation/navigation'

import { ZenEmptyComponent, ZenIcon, ZenText, ZenToast } from 'zen-core-elements'


import { useAppDispatch, useAppSelector } from '../../../redux/hooks'
import { storeLocation } from '../../../redux/slices/commonSliceType'
import { setCurrentLocation } from '../../../redux/slices/commonSlice'

import SellscreenModal from '../sellscreenModal'
import { DrawerActions } from '@react-navigation/native'

type LocationModalProps = {
	isModalOpen?: boolean
	setModalOpen?: React.Dispatch<React.SetStateAction<boolean>> | ((open: boolean) => void)
	showTrigger?: boolean
}

const LocationModal = ({
	isModalOpen: controlledModalOpen,
	setModalOpen: setControlledModalOpen,
	showTrigger = true,
}: LocationModalProps = {}) => {
	const [internalModalOpen, setInternalModalOpen] = useState(false);
	const isModalOpen = controlledModalOpen !== undefined ? controlledModalOpen : internalModalOpen;
	const setModalOpen = setControlledModalOpen || setInternalModalOpen;

	const { width, height } = useWindowDimensions()
	const scrollRef = useRef<FlatList>(null)
	const dispatch = useAppDispatch()
	const navigation = useAppNavigation()
	//variable to store location id
	const { currentLocation: { id: locationId, name: locationName }, getStoreLocations: { value: locationData } } = useAppSelector((state) => state?.common)

	useEffect(() => {
		if (locationData && isModalOpen) {
			let findIndex = locationData?.findIndex((item) => item?.id == locationId)
			if (findIndex != null && findIndex >= 0) {
				scrollRef?.current?.scrollToIndex({ index: findIndex, animated: true })
			}
		}
	}, [locationData, isModalOpen])

	const handleSelect = (item: storeLocation) => {

		dispatch(setCurrentLocation({ id: item?.id, name: item?.locationName, timeZone: item.timeZone }))
		let payload = {
			limit: 10,
			offset: 0,
			categoryId: "",
			searchText: "",
			locationId: item?.id
		}
		dispatch(getCategoryProductsForSellScreen({ storeId: config?.storeId, payload })).unwrap().catch(err => {
			ZenToast({ message: err?.message, type: "error" })
		})
		DeviceEventEmitter.emit('DRAWER_CLOSE')
		setModalOpen(false)
	}
	const renderItem = ({ item }: { item: storeLocation }) => {
		const isSelected = locationId === item.id;

		return (
			<ThemeConsumer>
				{({ theme }) => {
					const styles = style(theme)
					return (
						(
							<TouchableOpacity
								activeOpacity={0.7}
								onPress={() => handleSelect(item)}
								style={[
									styles.card,
									isSelected && styles.cardSelected,
								]}
							>
								{/* Left Icon */}
								<View style={[styles.iconContainer, isSelected && styles.iconContainerSelected]}>
									<ZenIcon
										name='map-pin'
										type='feather'
										size={20}
										color={isSelected ? theme?.light : theme?.lightGrey}
									/>
								</View>

								{/* Text Content */}
								<View style={styles.textContainer}>
									<ZenText content={item.locationName} style={[styles.locationName, isSelected && styles.textSelected]} numberOfLines={Platform.OS === 'web' ? 1 : undefined} />
									<ZenText content={item.timeZone ? item.timeZone : "Time zone not found"} style={[styles.locationAddress]} numberOfLines={1} />
								</View>

								{/* Right Indicator (Radio/Check) */}
								<View style={[styles.radio, isSelected && styles.radioSelected]}>
									{isSelected && <ZenIcon name="check" type='feather' size={14} color={theme?.light} />}
								</View>
							</TouchableOpacity>
						)
					)
				}}
			</ThemeConsumer>
		)
	};
	return (
		<ThemeConsumer>
			{({ theme }) => {
				const styles = style(theme)
				return (
					<>
						{showTrigger && (
							<TouchableOpacity style={{ backgroundColor: theme?.coolGray, paddingVertical: 6, paddingHorizontal: 10, borderRadius: 20 }}
								onPress={() => setModalOpen(true)}
							>
								<ZenText content={`📍 ${locationName}`} style={{ fontSize: theme?.miniFontSize, fontFamily: theme?.medium, color: theme?.lightDark }} />
							</TouchableOpacity>
						)}

						<SellscreenModal isModalOpen={isModalOpen} setModalOpen={setModalOpen}>
							<View style={[{ maxWidth: width > 900 ? width * 0.30 : width > 600 ? width * 0.60 : width * 0.80, maxHeight: width > 900 ? height * 0.60 : height * 0.40, }, webDialogWidth('sm', width)]}>

								{/* Header */}
								<View style={styles.header}>
									<View>
										<ZenText content={"Select Location"} style={styles.title} />
										<ZenText content={"Where is this sale taking place?"} style={styles.subtitle} />
									</View>
									<TouchableOpacity onPress={() => { setModalOpen(false) }} style={styles.closeButton}>
										<ZenIcon name='close' type='antdesign' size={20} color={theme?.disabledGray500} />
									</TouchableOpacity>
								</View>

								<FlatList
									ref={scrollRef}
									data={locationData}
									renderItem={renderItem}
									keyExtractor={(item) => item.id?.toString()}
									contentContainerStyle={styles.listContent}
									/**
									 * 16.11: no visible bar, scrolling untouched.
									 *
									 * This line is also a correction. Replacing it with a web override
									 * in the previous step left Android on react-native's default, which
									 * is to *show* the indicator - an unintended native change. It is
									 * back to the explicit false it has always had, and the web marker
									 * beside it covers the browsers that ignore the property
									 * react-native-web emits for it.
									 */
									showsVerticalScrollIndicator={false}
									{...webHiddenScrollbarProps}
									ItemSeparatorComponent={() => <View style={{ height: 12 }} />}
									ListEmptyComponent={
										<ZenEmptyComponent viewStyle={{ flex: 1, justifyContent: "center", alignItems: "center" }} />
									}
									onScrollToIndexFailed={(info) => {
										setTimeout(() => {
											scrollRef.current?.scrollToIndex({
												index: info.index,
												animated: true,
											});
										}, 100);
									}}
								/>
							</View>
						</SellscreenModal>
					</>
				)
			}}
		</ThemeConsumer>
	)
}

const style = (theme: Theme) => (
	StyleSheet.create({
		header: {
			width: "100%",
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'flex-start',
			marginBottom: 20,
			gap: 15
		},
		title: {
			fontSize: theme?.smallerFontSize,
			fontFamily: theme?.bold,
			color: theme?.lightDark,
			letterSpacing: -0.5,
		},
		subtitle: {
			fontSize: theme?.badgeFontSize,
			fontFamily: theme?.medium,
			color: theme?.grey,
			marginTop: 4,
		},
		closeButton: {
			padding: 4,
			backgroundColor: theme?.softSlate,
			borderRadius: 20,
		},
		listContent: {
			paddingBottom: 20,
			flexGrow: 1
		},
		card: {
			flexDirection: 'row',
			alignItems: 'center',
			padding: 16,
			borderRadius: 16,
			backgroundColor: theme?.light,
			borderWidth: 1.5,
			borderColor: theme?.coolGray,
		},
		cardSelected: {
			borderColor: theme?.draggerIcon,
			backgroundColor: theme?.blue50,
		},
		iconContainer: {
			width: 40,
			height: 40,
			borderRadius: 20,
			backgroundColor: theme?.softSlate,
			justifyContent: 'center',
			alignItems: 'center',
			marginRight: 16,
		},
		iconContainerSelected: {
			backgroundColor: theme?.draggerIcon,
		},
		textContainer: {
			flex: 1,
		},
		locationName: {
			fontSize: theme?.smallFontSize,
			fontFamily: theme?.medium,
			color: theme?.lightDark,
			marginBottom: 2,
		},
		textSelected: {
			fontFamily: theme?.bold,
			color: theme?.lightDark,
		},
		locationAddress: {
			fontSize: theme?.miniFontSize,
			fontFamily: theme?.medium,
			color: theme?.grey,
		},

		radio: {
			width: 24,
			height: 24,
			borderRadius: 12,
			borderWidth: 2,
			borderColor: theme?.coolGray,
			justifyContent: 'center',
			alignItems: 'center',
		},
		radioSelected: {
			borderColor: theme?.tealGreen,
			backgroundColor: theme?.tealGreen,
		},
	})
)

export default LocationModal